import React from "react";
import { StepId } from "../../../constants/navigation";
import { StepFlowGate } from "../../Navigator/StepFlowGate";
import { useSessionDataStore } from "../../../hooks/useSessionDataStore";
import { CookieSyncSetup } from "./CookieSyncSetup";
import { isEmptyString } from "../../../utils/commonUtils";
import { StreamingUrlSetup } from "./StreamingUrlSetup";

// TODO [LOWA-30534] from https://tiny.amazon.com/60koy8d5
export const PreStreamingStep = () => {
    const cookieSyncTarget = useSessionDataStore(
        (store) => store.cookieSyncTarget
    );
    const streamingUrl = useSessionDataStore((store) => store.streamingUrl);

    if (!cookieSyncTarget) {
        return <CookieSyncSetup />;
    }

    if (isEmptyString(streamingUrl)) {
        return <StreamingUrlSetup />;
    }

    return <StepFlowGate isCompleted completedStepId={StepId.PRE_STREAMING} />;
};
